import event from "./event/eventReducer";
import service from "./service/serviceReducer";
import coreEvents from "./core-events/coreEventServiceReducer";
import accounts from "./accounts/accountsReducer";

import { combineReducers } from "redux";

const rootReducer = combineReducers({ event, service, coreEvents, accounts });
export default rootReducer;
